import { computed } from 'vue'

export function useModelWrapper(props, emit, name = 'modelValue', type = null) {
	return computed({
		get: () => props[name],
		set: (value) => {
			switch (type) {
				case null:
					emit(`update:${name}`, value)
					break
				case 'object':
					emit(`update:${name}`, value.value)
					break
			}
		},
	})
}
